// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__62cWP","fadeIn":"Backdrop_fadeIn__zj7lQ","transparent":"Backdrop_transparent__Ltbtj","light":"Backdrop_light__2_xmc"};